import { Badge, Box, Flex, SegmentedControl, Space, Text } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import React from "react";
import { useSelector } from "react-redux";
import { ProgramApi } from "../../apis";
import { IGeneral } from "../../interfaces/IGeneral";
import { IReference } from "../../interfaces/IReference";
import { IScfProgram } from "../../interfaces/IScfProgram";
import { tugrug } from "../../utils";
import { PageFilter } from "../layout";
import { ColumnType, Table } from "../table";
import RenderText from "../ui/render-text";

export const ScfFinanceLimitBuyerLedList = () => {
  const [status, setStatus] = React.useState("");
  const [statusDebounced] = useDebouncedValue(status, 400);
  const { programStatus } = useSelector((state: { general: IGeneral }) => state.general);

  const columns = useHeader({
    programStatus,
    tugrug,
    onClick: (key, record) => {
      switch (key) {
        case "detail": {
          break;
        }
        default:
      }
    },
  });

  return (
    <>
      <PageFilter
        left={[
          <Flex justify="flex-start" align="flex-start" direction="column" wrap="wrap" key={1}>
            <Text size={14} color="#868E96">
              Хөтөлбөрийн статус
            </Text>
            <SegmentedControl
              key={1}
              onChange={(e) => setStatus(e)}
              value={status}
              data={[{ name: "Бүгд", code: "", color: "yellow" }, ...programStatus].map((item: IReference, index: number) => {
                return {
                  value: item.code || "",
                  label: (
                    <Badge variant="dot" color={item.color} style={{ border: "none" }} key={`${index}`}>
                      {item.name}
                    </Badge>
                  ),
                };
              })}
            />
          </Flex>,
        ]}
      />
      <Space h="sm" />
      <Table
        name="scf.finance.limit.list"
        columns={columns}
        filters={{ query: "", status: statusDebounced, productType: "BUYER_LED" }}
        loadData={(data) => ProgramApi.list(data!)}
      />
    </>
  );
};

const useHeader = ({
  onClick,
  programStatus,
  tugrug,
}: {
  onClick: (key: string, record: IScfProgram) => void;
  programStatus: IReference[];
  tugrug: any;
}): ColumnType<IScfProgram>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Хөтөлбөр #",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => {
      return <RenderText text={record.refCode || "-"} />;
    },
  },
  {
    title: "Хөтөлбөрийн нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => {
      return <RenderText text={record?.name || "-"} />;
    },
  },
  {
    title: "Хөтөлбөрийн статус",
    sorter: true,
    dataIndex: "programStatus",
    render: (record) => {
      return (
        <Badge size="md" radius="sm" variant="outline" color={(programStatus || []).find((item: IReference) => item.code === record?.programStatus)?.color}>
          {(programStatus || []).find((item: IReference) => item.code === record?.programStatus)?.name ?? "-"}
        </Badge>
      );
    },
  },
  {
    title: "Хөтөлбөрийн лимит",
    sorter: true,
    dataIndex: "programLimit",
    render: (record) => {
      return <RenderText text={tugrug(record.programLimit || "0")} isAmount />;
    },
  },
  {
    title: "Боломжит лимит",
    sorter: true,
    dataIndex: "availableAmount",
    render: (record) => {
      return <RenderText text={tugrug(record.availableAmount || "0")} isAmount />;
    },
  },
  {
    title: "Ашигласан лимит",
    sorter: true,
    dataIndex: "utilizedAmount",
    render: (record) => {
      return <RenderText text={tugrug(record.utilizedAmount || "0")} isAmount />;
    },
  },
  {
    title: "Олголт хүлээж буй",
    sorter: true,
    dataIndex: "toDisburseAmount",
    render: (record) => {
      return <RenderText text={tugrug(record.toDisburseAmount || "0")} isAmount />;
    },
  },
  {
    title: "Хүсэлт хүлээн авсан",
    sorter: true,
    dataIndex: "disbursedAmount",
    render: (record) => {
      return <RenderText text={tugrug(record.disbursedAmount || "0")} isAmount />;
    },
  },
  {
    title: "Корпорэйт анкор",
    sorter: true,
    dataIndex: "businessName",
    render: (record) => {
      return <RenderText text={record?.anchor?.partner?.businessName || "-"} />;
    },
  },
  {
    title: "Анкор бизнес нэр",
    sorter: true,
    dataIndex: "profileName",
    render: (record) => {
      return <RenderText text={record?.anchor?.profileName || "-"} />;
    },
  },
  {
    title: "Анкор роль",
    sorter: true,
    dataIndex: "role",
    render: (record) => {
      return (
        <Box>
          <RenderText text={record?.anchor?.refCode || "-"} color="#3e166e" />
          <RenderText text={record?.anchor?.profileName || "-"} />
        </Box>
      );
    },
  },
  {
    title: "SME тоо",
    sorter: true,
    dataIndex: "participantCount",
    render: (record) => {
      return <RenderText text={record.smeCount || "0"} />;
    },
  },
];
